import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { close as closeAction } from '../../../modules/modal/actions';
import Translation from '../../i18n/Translation';

export const SlipNotSettled = ({ close }) => (
  <div className="modal">
    <h2 className="modal__header">
      <Translation section="transfer" label="modalTitle" />
    </h2>
    <p className="modal__paragraph">
      <Translation section="transfer" label="slipNotSettled1" />
    </p>
    <p className="modal__paragraph">
      <Translation section="transfer" label="slipNotSettled2" />
    </p>
    <Button className="modal__button" onClick={close}>
      <Translation section="common" label="close" />
    </Button>
  </div>
);

SlipNotSettled.propTypes = {
  close: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  close: closeAction
};

export default connect(null, mapDispatchToProps)(SlipNotSettled);
